<template>
  <client-only>
    <el-dialog
      :close-on-click-modal="false"
      :model-value="verificationLimitDialogShow"
      :class="$style.VerificationLimitDIalog"
      @close="onClose"
      @closed="onClosed"
    >
      <div
        :class="$style.VerificationLimitDIalog__title"
        v-html="verificationLimitDialogConfig ? verificationLimitDialogConfig.title : 'Title'"
      />
      <div
        :class="$style.VerificationLimitDIalog__wrapper"
        v-if="verificationLimitDialogConfig && verificationLimitDialogConfig.items"
      >
        <div
          :class="$style.wrapperItem"
          v-for="configItem in verificationLimitDialogConfig.items"
          :key="configItem.desc"
        >
          <div :class="$style.wrapperItem__text">{{ configItem.desc }}</div>
          <div v-if="configItem.url" @click="onClose">
            <span
              v-if="typeof configItem.url === 'function'"
              :class="$style.wrapperItem__btn"
              @click="configItem.url"
              >{{ configItem.btn }}</span
            >
            <a
              v-else-if="configItem.url.startsWith('bitmart:')"
              :class="$style.wrapperItem__btn"
              :href="configItem.url"
              @click="onClose"
              >{{ configItem.btn }}</a
            >
            <NuxtLink v-else :class="$style.wrapperItem__btn" :to="configItem.url">
              {{ configItem.btn }}
            </NuxtLink>
          </div>
          <div v-else :class="$style.wrapperItem__unuse">
            {{ configItem.btn }}
          </div>
        </div>
      </div>
    </el-dialog>
  </client-only>
</template>

<style lang="less" module>
.VerificationLimitDIalog {
  background-color: #fff;
  max-width: 480px;
  background: #ffffff;
  border-radius: 8px;
  width: 90%;

  :global {
    .el-dialog__header {
      padding-top: 24px;
    }
    .el-dialog__body {
      padding: 0 40px;
      padding-bottom: 32px;
    }
  }

  &__title {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    color: #000;
    word-break: keep-all;
  }

  &__wrapper {
    margin-top: 16px;
    .wrapperItem {
      display: flex;
      justify-content: space-between;
      margin-top: 8px;
      align-items: center;
      background: #f3f4f8;
      box-sizing: border-box;
      border-radius: 8px;
      padding: 8px 17px;
      min-height: 56px;
      &:nth-child(1) {
        margin-top: 0;
      }
      &__text {
        font-style: normal;
        font-weight: normal;
        word-break: keep-all;
        font-size: 14px;
        color: #000;
        max-width: 260px;
      }
      &__btn {
        color: #13c2c2;
        white-space: nowrap;
        font-size: 14px;
        cursor: pointer;
      }
      &__unuse {
        white-space: nowrap;
        font-size: 14px;
      }
    }
  }
}

@media (max-width: 480px) {
  .VerificationLimitDIalog {
    :global {
      .el-dialog__body {
        padding: 0 19px 19px;
      }
      .el-dialog__header {
        padding-top: 24px;
      }
    }
    &__wrapper {
      margin-top: 10px;
      .wrapperItem {
        margin-top: 2px;
        padding: 8px 13px;
        min-height: 48px;
        &__text {
          max-width: 210px;
          font-size: 12px;
        }
        &__btn {
          font-size: 12px;
        }
        &__unuse {
          font-size: 12px;
        }
      }
    }
    &__title {
      font-size: 14px;
      line-height: 16px;
    }
  }
}
</style>

<script>
import { mapState, usePatchStore } from '~/common/js/patch'

let onpopstate = null // 离开页面的回调

export default {
  name: 'VerificationLimitDIalog',
  data() {
    return {
      isApp: false,
    }
  },
  computed: {
    ...mapState({
      verificationLimitDialogShow: (state) => state.verificationLimitDialogShow,
      locale: (state) => state.locale,
      bindGoogle: (state) => state.account.bindGoogle,
      bindPhone: (state) => state.account.bindPhone,
      bindEmail: (state) => state.account.bindEmail,
      kycLevel: (state) => state.account.kycLevel,
      kycStatusCode: (state) => state.account.identityImgStatus,
      verificationLimitDialogType: (state) => state.verificationLimitDialogType,
      is2FA: (state) => state.account.is2FA
    }),
    // 老用户，新用户kycLevel>=1
    hasCompleteStarter() {
      return (+this.kycLevel === 0 && +this.kycStatusCode != 0) || +this.kycLevel >= 1
    },
    // 根据类型使用对应的数据
    verificationLimitDialogConfig: function () {
      const TYPE_CONFIG = {
        DEPOSIT_BUY: {
          title: this.$t('kyc.verify_limit_dialog_deposit_buy_title'),
          items: [
            {
              desc: this.$t('kyc.verify_limit_dialog_deposit_buy_starter_desc'),
              btn: this.$t('kyc.verify_limit_dialog_verify_now'),
              url: this.verifyLink,
            },
          ],
        },
        WITHDRAW_SELL: {
          title: this.$t('kyc.verify_limit_dialog_withdraw_sell_title'),
          items: [
            {
              desc: this.$t('kyc.verify_limit_dialog_withdraw_sell_2fa_desc'),
              btn: this.is2FA
                ? this.$t('kyc.verify_limit_dialog_withdraw_sell_2fa_btn_enabled')
                : this.$t('kyc.verify_limit_dialog_withdraw_sell_2fa_btn_toenable'),
              url: this.is2FA
                ? ''
                : () => {
                    this.store.commit('SHOW_MFA_VERIFY_NOTICE_VISIBLE')
                  },
            },
            {
              desc: this.$t('kyc.verify_limit_dialog_withdraw_sell_starter_desc'),
              btn: this.hasCompleteStarter
                ? this.$t('kyc.verify_limit_dialog_verified')
                : this.$t('kyc.verify_limit_dialog_verify_now'),
              url: this.hasCompleteStarter ? '' : this.verifyLink,
            },
          ],
        },
        TRADE_EARN_SHOOT_FUTURE: {
          title: this.$t('kyc.verify_limit_dialog_Trade_Earn_Shoot_Future_title'),
          items: [
            {
              desc: this.$t('kyc.verify_limit_dialog_Trade_Earn_Shoot_Future_starter_desc'),
              btn: this.$t('kyc.verify_limit_dialog_verify_now'),
              url: this.verifyLink,
            },
          ],
        },
      }
      return TYPE_CONFIG[this.verificationLimitDialogType] || null
    },
    // 认证页面链接
    verifyLink() {
      return this.isApp ? 'bitmart://account?page=kyc' : `/verify/${this.locale}`
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (window.jsBridge) {
        this.isApp = true
      }
    })
    onpopstate = this.popstate.bind(this)
    window.addEventListener('popstate', onpopstate)
  },
  beforeDestroy() {
    window.removeEventListener('popstate', onpopstate)
    onpopstate = null
  },
  methods: {
    onClose() {
      this.store.commit('HIDE_VERIFICATION_LIMIT_DIALOG')
    },
    // 完全关闭后清除弹窗内容
    onClosed() {
      this.store.commit('SET_VERIFICATION_LIMIT_DIALOG_TYPE', '')
    },
    popstate() {
      // 处理回退退出弹窗
      this.store.commit('HIDE_VERIFICATION_LIMIT_DIALOG')
    },
  },
  setup() {
    const { store } = usePatchStore()
    return {
      store
    }
  },
}
</script>
